import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing }) => ({
  root: {
    display: "flex",
    height: "calc(100vh - 64px)",
    justifyContent: "center",
    alignItems: "center",
  },
  copyright: {
    marginBottom: spacing(5),
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    width: 480,
    margin: "auto",
    border: `1px solid ${grey[300]}`,
    borderRadius: spacing(1),
    backgroundColor: "#ffffff",
    padding: spacing(3),
  },
  title: {
    lineHeight: 1,
    fontWeight: 500,
    textAlign: "center",
  },
  message: {
    color: grey[700],
    textAlign: "center",
  },
}));

export default styles;
